<template>
  <div class="resource-password-row">
    <span class="password" :class="{ smallText: !this.showPassword }" :title="formattedPassword">
      {{ formattedPassword || '-' }}
    </span>
    <div class="password-icons">
      <v-icon class="icon show-password" small v-if="toggleable" @click="toggleShowPassword">{{
        visibilityIcon
      }}</v-icon>
      <v-icon class="icon copy-password" small v-if="copiable" @click="copyPasswordToClipboard">content_copy</v-icon>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ResourcePasswordRow',
  props: {
    password: {
      type: String,
      required: true,
    },
    copiable: {
      type: Boolean,
      default: true,
    },
    toggleable: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    showPassword: false,
  }),
  computed: {
    formattedPassword() {
      return this.password?.length && this.showPassword ? this.password : '● '.repeat(this.password.length);
    },
    visibilityIcon() {
      return this.showPassword ? 'visibility_off' : 'visibility';
    },
  },
  methods: {
    toggleShowPassword() {
      this.showPassword = !this.showPassword;
    },
    copyPasswordToClipboard() {
      this.$clipboard(this.password);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.resource-password-row {
  display: flex;
  align-items: center;
  border-radius: $radius-sm;
  background-color: var(--bg-tertiary);
  height: rem(28);
  padding: rem(6);
  margin-bottom: rem(2);

  .password {
    display: inline;

    &.smallText {
      font-size: rem(10);
    }
  }

  .password-icons {
    display: flex;

    .icon {
      margin-left: rem(15);

      &.show-password {
        color: var(--text-tertiary);
      }

      &.copy-password {
        color: var(--brand-primary);
      }
    }
  }
}
</style>
